import { DatePicker, Select } from "antd";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import moment from "moment"; // Import moment để xử lý ngày
export const roomOptions = [
  { value: "Double Standard", label: "Double Standard" },
  { value: "Double Premium", label: "Double Premium" },
  { value: "Double Twin", label: "Double Twin" },
  { value: "Triple Deluxe", label: "Triple Deluxe" },
  { value: "Double-double Standard", label: "Double-double Standard" },
  { value: "Double-double Premium", label: "Double-double Premium" },
];
const BookingForm = () => {
  const { t } = useTranslation();
  const [formData, setFormData] = useState({
    name: "",
    phone: "",
    email: "",
    roomType: null,
    quantity: "",
    date: null, // Thay đổi từ string thành null để phù hợp với DatePicker
  });

  const [isSubmitting, setIsSubmitting] = useState(false);
  const [message, setMessage] = useState("");

  const handleChange = (e) => {
    const { name, value } = e.target;

    if (name === "quantity" && value < 0) {
      return;
    }

    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleDateChange = (date, dateString) => {
    // dateString sẽ có định dạng "DD/MM/YYYY"
    setFormData((prevData) => ({
      ...prevData,
      date: dateString, // Lưu chuỗi ngày dạng "DD/MM/YYYY"
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setMessage("");

    const { name, phone, email, roomType, quantity, date } = formData;

    if (!name || !phone || !email || !roomType || !quantity || !date) {
      setMessage("Vui lòng điền đầy đủ thông tin trước khi đặt phòng.");
      setIsSubmitting(false);
      return;
    }

    const payload = {
      ...formData,
      date: date, // Đã ở định dạng "DD/MM/YYYY"
    };

    try {
      const response = await fetch(
        "http://103.45.232.48:10002/api/send-email",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(payload),
        }
      );

      if (response.ok) {
        setMessage("Đặt phòng thành công!");
        setFormData({
          name: "",
          phone: "",
          email: "",
          roomType: null,
          quantity: "",
          date: null, // Reset về null
        });
      } else {
        setMessage("Đã xảy ra lỗi khi gửi form. Vui lòng thử lại.");
      }
    } catch (error) {
      console.error("Error submitting form:", error);
      setMessage("Không thể kết nối đến server. Vui lòng thử lại sau.");
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <form
      onSubmit={handleSubmit}
      className="flex flex-col lg:flex-row lg:flex-wrap rounded-md w-full lg:bg-transparent lg:p-0 lg:gap-0 ssx:bg-slate-50 ssx:p-2 ssx:gap-2 font-cormorant"
    >
      <input
        type="text"
        name="name"
        value={formData.name}
        onChange={handleChange}
        placeholder={t("FULL_NAME")}
        className="lg:border-r outline-none hover:shadow px-[5px] ssx:py-[5px] w-full lg:w-[14%] ssx:w-[100%] text-sm lg:text-[14px]"
        required
      />
      <input
        type="text"
        name="phone"
        value={formData.phone}
        onChange={handleChange}
        placeholder={t("PHONE_NUMBER")}
        className="lg:border-r outline-none hover:shadow px-[5px] ssx:py-[5px] w-full lg:w-[14%] ssx:w-[100%] text-sm lg:text-[14px]"
        required
      />
      <input
        type="text"
        name="email"
        value={formData.email}
        onChange={handleChange}
        placeholder={t("EMAIL")}
        className="lg:border-r outline-none hover:shadow px-[5px] ssx:py-[5px] w-full lg:w-[14%] ssx:w-[100%] text-sm lg:text-[14px]"
        required
      />
      <Select
        name="roomType"
        value={formData?.roomType}
        onChange={(value) =>
          setFormData((prevData) => ({
            ...prevData,
            roomType: value,
          }))
        }
        allowClear
        options={roomOptions}
        showSearch
        placeholder={t("SELECT_ROOM_TYPE")}
        className="lg:border-r font-medium outline-none hover:shadow  w-full lg:w-[14%] ssx:w-[100%] text-sm lg:text-[14px] font-cormorant"
        required
      />

      <input
        type="number"
        name="quantity"
        value={formData.quantity}
        placeholder={t("NUMBER_OF_PEOPLE")}
        onChange={handleChange}
        className="lg:border-r outline-none hover:shadow px-[5px] ssx:py-[5px] w-full lg:w-[14%] text-sm lg:text-[14px]"
        min="0"
        required
      />

      <DatePicker
        format="DD/MM/YYYY"
        onChange={handleDateChange}
        value={formData.date ? moment(formData.date, "DD/MM/YYYY") : null}
        placeholder={t("Chọn ngày")}
        className="font-cormorant lg:border-r outline-none font-medium hover:shadow px-[5px] ssx:py-[5px] w-full lg:w-[14%] ssx:w-[100%] text-sm lg:text-[14px] text-gray-400"
        style={{ borderRadius: 0 }}
        required
      />
      <button
        type="submit"
        className="bg-[#D4AF37] text-black py-2 px-2 hover:bg-yellow-600 w-full lg:w-[14%] text-sm lg:text-[14px]"
        disabled={isSubmitting}
      >
        {isSubmitting ? t("BOOK_NOW1") : t("BOOK_NOW1")}
      </button>
    </form>
  );
};

export default BookingForm;
